<template>
  <div class="myfoot">
    <p>© 2026 rpgRoot.com | contact@rpgRoot.com</p>
    <p>
      <a
        class="patreon-button"
        href="https://www.patreon.com/c/rpgRoot/membership"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Join us on Patreon"
      >
        <img
          id="patreonLogo"
          src="../assets/patreon.svg"
          alt="Patreon"
          width="170"
        />
      </a>
    </p>
    <p>
      <router-link to="/api">API</router-link> |
      <router-link to="/glossary">Glossary</router-link>
    </p>
    <span>#{{ commitHash }} {{ tag }} :: {{ buildTime }}</span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

declare const __VITE_GIT_HASH__: string;
declare const __VITE_GIT_TAG__: string;
declare const __VITE_BUILD_TIME__: string;

@Options({
  data() {
    console.log(__VITE_GIT_TAG__);
    return {
      buildTime: __VITE_BUILD_TIME__ || new Date().toISOString(),
      commitHash: __VITE_GIT_HASH__,
      tag: __VITE_GIT_TAG__ ? ` / ${__VITE_GIT_TAG__}` : ''
    };
  }
})
export default class Footer extends Vue {}
</script>

<style scope>
.myfoot {
  color: #fff;
}
.myfoot span {
  font-size: 0.8em;
  color: gray;
}
a {
  color: rgb(255, 175, 110);
}
</style>
